import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d57b3cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["pdf-key"]
const _hoisted_2 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_3 = {
  class: "flex flex-col",
  style: {"height":"1020px"}
}
const _hoisted_4 = { class: "text-lg md:text-lg" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" IST-Einstellparameter - ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Bezeichnung"),
  /*#__PURE__*/_createElementVNode("th", null, "Wert"),
  /*#__PURE__*/_createElementVNode("th", null, "Optimierung empfohlen")
], -1))
const _hoisted_8 = { class: "border-bottom" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Pumpe", -1))
const _hoisted_10 = { class: "border-bottom" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Soll-Raumtemperatur", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "border-bottom" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Heizprogramm 1", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "border-bottom" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Heizprogramm 2", -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { style: {"width":"200px"} }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "border-bottom" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Sommerabschaltung", -1))
const _hoisted_28 = { class: "border-bottom" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Heizkennlinie", -1))
const _hoisted_30 = { class: "border-bottom" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Nachtabsenkung", -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_34 = {
  class: "flex flex-col",
  style: {"height":"1020px"}
}
const _hoisted_35 = { class: "text-lg md:text-lg" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Frage"),
  /*#__PURE__*/_createElementVNode("th", null, "Wert"),
  /*#__PURE__*/_createElementVNode("th", null, "Optimierungsbedarf")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_page_header = _resolveComponent("pdf-page-header")!
  const _component_universal_pdf_image_row = _resolveComponent("universal-pdf-image-row")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useEnsimimavPdf.getHeizkreisePages(_ctx.ba), (heizkreis, key) => {
    return (_openBlock(), _createElementBlock("div", {
      key: key,
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, [
      _createVNode(_component_pdf_a4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang,
        class: "pdf-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_pdf_page_header, {
                immobilie: _ctx.immobilie,
                hzba: _ctx.ba,
                active: _ctx.Test,
                lang: _ctx.lang,
                "crumbs-beginning": '',
                "crumbs-middle": 'IST-Einstellparameter',
                "crumbs-end": ' > IST-Dämmung > Optimierungspotenzial > Mängel'
              }, null, 8, ["immobilie", "hzba", "active", "lang"]),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("b", null, "Heizkreis " + _toDisplayString(key+1) + " (" + _toDisplayString(heizkreis['regularFrages']['bezeichnung']) + ")", 1)
              ]),
              _hoisted_6,
              _createElementVNode("table", null, [
                _hoisted_7,
                _createElementVNode("tr", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['pumpe']), 1),
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['optimierungsbedarfpumpe']), 1)
                ]),
                _createElementVNode("tr", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("td", null, [
                    _createTextVNode("Tag: " + _toDisplayString(heizkreis['regularFrages']['sollraumtemperaturtag']) + " °C ", 1),
                    _hoisted_12,
                    _createTextVNode(" Nacht: " + _toDisplayString(heizkreis['regularFrages']['sollraumtemperaturnacht']) + " °C", 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['optimierungsbedarfsollraumtemperature']), 1)
                ]),
                _createElementVNode("tr", _hoisted_13, [
                  _hoisted_14,
                  (heizkreis['regularFrages']['einstellungheizprogramm1tagvon'] !== null && heizkreis['regularFrages']['einstellungheizprogramm1tagbis'] !== null && heizkreis['regularFrages']['einstellungheizprogramm1tagbis'] !== null && heizkreis['regularFrages']['einstellungheizprogramm1bis'] !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("td", null, "Von " + _toDisplayString(heizkreis['regularFrages']['einstellungheizprogramm1tagvon']) + " bis " + _toDisplayString(heizkreis['regularFrages']['einstellungheizprogramm1tagbis']) + ": " + _toDisplayString(heizkreis['regularFrages']['einstellungheizprogramm1von']) + " - " + _toDisplayString(heizkreis['regularFrages']['einstellungheizprogramm1bis']), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18)),
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['optimierungsbedarfheizprogramm1']), 1)
                ]),
                _createElementVNode("tr", _hoisted_19, [
                  _hoisted_20,
                  (heizkreis['regularFrages']['einstellungheizprogramm2tagbis'] !== null && heizkreis['regularFrages']['einstellungheizprogramm2tagbis'] !== null && heizkreis['regularFrages']['einstellungheizprogramm2von'] !== null && heizkreis['regularFrages']['einstellungheizprogramm2bis'] !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("td", _hoisted_22, " Von " + _toDisplayString(heizkreis['regularFrages']['einstellungheizprogramm2tagvon']) + " bis " + _toDisplayString(heizkreis['regularFrages']['einstellungheizprogramm2tagbis']) + ": " + _toDisplayString(heizkreis['regularFrages']['einstellungheizprogramm2von']) + " - " + _toDisplayString(heizkreis['regularFrages']['einstellungheizprogramm2bis']), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25)),
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['optimierungsbedarfheizprogramm2']), 1)
                ]),
                _createElementVNode("tr", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['sommerabschaltung'] ? heizkreis['regularFrages']['sommerabschaltung'] : "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['optimierungsbedarfsommerabschaltung']), 1)
                ]),
                _createElementVNode("tr", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['heizkennlinie'] ? heizkreis['regularFrages']['heizkennlinie'] : "Nicht Vorhanden"), 1),
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['optimierungsbedarfheizkennlinie']), 1)
                ]),
                _createElementVNode("tr", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['nachtabsenkung'] ? "Vorhanden" : "Nicht Vorhanden"), 1),
                  _createElementVNode("td", null, _toDisplayString(heizkreis['regularFrages']['optimierungsbedarnachtabsenkung']), 1)
                ])
              ]),
              _createElementVNode("table", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(heizkreis['customParametersPages'][0], (customRow, outerKey) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (outerKey < 8)
                      ? (_openBlock(), _createElementBlock("tr", {
                          key: outerKey,
                          class: "border-bottom"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customRow, (frage, key) => {
                            return (_openBlock(), _createElementBlock("td", { key: key }, _toDisplayString(frage), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]),
              _createVNode(_component_universal_pdf_image_row, {
                "max-images": 5,
                "hide-titles": true,
                stretch: false,
                "image-objects": [].concat(
              heizkreis['regularFrages']['typenschildmischer'],
              heizkreis['regularFrages']['typenschildregelung'],
              heizkreis['regularFrages']['typenschildpumpe'],
              heizkreis['regularFrages']['einstellkurvepumpe'])
              }, null, 8, ["image-objects"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      (heizkreis['customParametersPages'].length !== 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(heizkreis['customParametersPages'], (customPage, customPageKey) => {
              return (_openBlock(), _createElementBlock("span", { key: customPageKey }, [
                (!(customPageKey === 0))
                  ? (_openBlock(), _createBlock(_component_pdf_a4_page, {
                      key: 0,
                      "no-margin": "",
                      "pdf-key": _ctx.lang,
                      class: "pdf-content"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_pdf_page_header, {
                              immobilie: _ctx.immobilie,
                              hzba: _ctx.ba,
                              active: _ctx.Test,
                              lang: _ctx.lang,
                              "crumbs-beginning": '',
                              "crumbs-middle": 'IST-Einstellparameter',
                              "crumbs-end": ' > IST-Dämmung > Optimierungspotenzial > Mängel'
                            }, null, 8, ["immobilie", "hzba", "active", "lang"]),
                            _createElementVNode("div", _hoisted_35, "Weitere IST-Einstellparameter (" + _toDisplayString(customPageKey) + ") - Heizkreis " + _toDisplayString(key+1), 1),
                            _hoisted_36,
                            _createElementVNode("table", null, [
                              _hoisted_37,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customPage, (customRow, key) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  (!(customPageKey == 0 && key < 8))
                                    ? (_openBlock(), _createElementBlock("tr", {
                                        key: key,
                                        class: "border-bottom"
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customRow, (frage, key) => {
                                          return (_openBlock(), _createElementBlock("td", { key: key }, _toDisplayString(frage), 1))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 256))
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["pdf-key"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1))
  }), 128))
}